// ReviewStars component
"use client";

import React from 'react';
import { Rating, ThinStar } from '@smastrom/react-rating';
import { shadeColor } from "@/lib/utils";
import Link from 'next/link';

interface ReviewStarsSmallProps {
  count: number;
  rating: number;
  hexColour: string;
  slug: string;
}

const ReviewStarsSmall: React.FC<ReviewStarsSmallProps> = ({ count, rating, hexColour, slug }) => {

    const myStyles = {
        itemShapes: ThinStar,
        activeFillColor: hexColour,
        inactiveFillColor: shadeColor(hexColour, 50)
    };

    return (
    <div className="flex flex-col items-center justify-center space-y-4 w-full mb-4">
        <div className="flex items-center justify-center w-1/2">
        <Rating
        style={{ maxWidth: 150 }}
        value={rating}
        readOnly
        halfFillMode='svg'
        itemStyles={myStyles}
        />
        </div>
        <div className="flex flex-col items-center justify-center px-4 w-full">
            <Link style={{ backgroundColor: hexColour }} className={`text-white font-bold py-2 px-4 rounded-md text-center mx-4 md:w-1/4 w-full`} href={`/${slug}/review`}>
                Leave Review
            </Link>
        </div>
        {/* If count is one show review else reviews */}
        <p style={{ color: hexColour}} className={`flex underline text-xs leading-5 text-center mx-4`}><Link href="#reviews">See all {count} review{count != 1 ? 's' : ''}</Link></p>
    </div>
    );
};

export default ReviewStarsSmall;